/* Softari — avaliações do produto: grade em colunas (cada cartão entra na coluna mais curta),
   ordenação, filtro por nota, "mostrar mais" e janela com a avaliação inteira. */
(function () {
  'use strict';

  var ESTRELA_CHEIA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289a.85.85 0 0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-.174L12 19.869l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z"/></svg>';
  var ESTRELA_VAZIA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="m16.399 14.574 4.413-4.283-6.086-.894L12 3.887l-2.726 5.51-6.086.894L7.6 14.574l-1.053 6.072L12 17.776l5.438 2.87-1.039-6.072ZM24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289 0 .48-.197.72-.591.72-.183 0-.375-.057-.577-.172L12 19.867l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z"/></svg>';
  var VERIFICADA = '<svg viewBox="0 0 24 24" aria-label="Verified purchase" role="img"><path fill="currentColor" d="m10.6 16.6 7.05-7.05-1.4-1.4-5.65 5.65-2.85-2.85-1.4 1.4 4.25 4.25ZM12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12a9.74 9.74 0 0 1 .788-3.9 10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2a9.74 9.74 0 0 1 3.9.788 10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Z"/></svg>';
  var PLAY = '<svg class="sftr-av__play" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="30.5" fill="none" stroke="currentColor" stroke-width="3"/><path d="M25 20.5v23L44 32z" fill="currentColor"/></svg>';

  function estrelas(n) {
    var cheias = Math.round(Number(n) || 0), h = '';
    for (var i = 1; i <= 5; i++) h += i <= cheias ? ESTRELA_CHEIA : ESTRELA_VAZIA;
    return h;
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function tamanho(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  // texto com o trecho destacado (o Loox dá 4px de folga de cada lado dele)
  function pintarTexto(alvo, t, marca) {
    alvo.textContent = '';
    var i = marca ? t.indexOf(marca) : -1;
    if (i < 0) { alvo.textContent = t; return; }
    alvo.appendChild(document.createTextNode(t.slice(0, i)));
    var m = document.createElement('mark'); m.className = 'sftr-av__marca'; m.textContent = marca;
    alvo.appendChild(m);
    alvo.appendChild(document.createTextNode(t.slice(i + marca.length)));
  }
  function data(ms) {
    try { return new Date(ms).toLocaleDateString(); } catch (e) { return ''; }
  }

  function Avaliacoes(raiz) {
    this.raiz = raiz;
    var dados = raiz.querySelector('[data-sftr-av-dados]');
    this.dados = JSON.parse(dados ? dados.textContent : '{}') || {};
    this.todos = (this.dados.itens || []).map(function (x, i) { x._o = i; return x; });
    this.inicial = parseInt(raiz.getAttribute('data-inicial'), 10) || 10;
    this.passo = parseInt(raiz.getAttribute('data-passo'), 10) || 10;
    this.titulo = raiz.getAttribute('data-titulo') || '';
    this.cor = getComputedStyle(raiz).getPropertyValue('--sftr-av-cor');
    this.ordem = 'featured';
    this.filtro = 0;
    this.mostrando = this.inicial;
    this.grade = raiz.querySelector('[data-grade]');
    this.maisCaixa = raiz.querySelector('[data-mais-caixa]');
    this.pintarEstrelas(raiz);
    this.cabecalho();
    this.janela();
    this.formulario();
    this.montar();
    var self = this, t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { self.arrumar(); }, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.arrumar(); });
  }

  Avaliacoes.prototype.pintarEstrelas = function (onde) {
    onde.querySelectorAll('.sftr-av__estrelas[data-nota]').forEach(function (s) { s.innerHTML = estrelas(s.getAttribute('data-nota')); });
  };

  /* ---- cabeçalho: distribuição, ordenação, escrever ---- */
  Avaliacoes.prototype.cabecalho = function () {
    var self = this, r = this.raiz;
    var distBotao = r.querySelector('[data-dist-botao]'), dist = r.querySelector('[data-dist]');
    var menuBotao = r.querySelector('[data-menu-botao]'), menu = r.querySelector('[data-menu]');
    function fecharTudo(exceto) {
      if (exceto !== dist && dist) { dist.hidden = true; distBotao.setAttribute('aria-expanded', 'false'); }
      if (exceto !== menu && menu) { menu.hidden = true; menuBotao.setAttribute('aria-expanded', 'false'); }
    }
    if (distBotao && dist) distBotao.addEventListener('click', function (e) {
      e.stopPropagation();
      var abrir = dist.hidden;
      fecharTudo(dist);
      dist.hidden = !abrir;
      distBotao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    });
    if (menuBotao && menu) menuBotao.addEventListener('click', function (e) {
      e.stopPropagation();
      var abrir = menu.hidden;
      fecharTudo(menu);
      menu.hidden = !abrir;
      menuBotao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    });
    [dist, menu].forEach(function (p) { if (p) p.addEventListener('click', function (e) { e.stopPropagation(); }); });
    document.addEventListener('click', function () { fecharTudo(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fecharTudo(null); });

    r.querySelectorAll('[data-filtro]').forEach(function (linha) {
      function escolher() {
        var n = parseInt(linha.getAttribute('data-filtro'), 10);
        self.filtro = self.filtro === n ? 0 : n;
        r.querySelectorAll('[data-filtro]').forEach(function (l) {
          l.setAttribute('aria-pressed', parseInt(l.getAttribute('data-filtro'), 10) === self.filtro ? 'true' : 'false');
        });
        self.mostrando = self.inicial;
        self.montar();
      }
      linha.addEventListener('click', escolher);
      linha.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); escolher(); } });
    });
    r.querySelectorAll('[data-ordem]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.ordem = b.getAttribute('data-ordem');
        r.querySelectorAll('[data-ordem]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        fecharTudo(null);
        self.mostrando = self.inicial;
        self.montar();
      });
    });
    var mais = r.querySelector('[data-mais]');
    if (mais) mais.addEventListener('click', function () { self.mostrando += self.passo; self.montar(true); });
  };

  Avaliacoes.prototype.lista = function () {
    var f = this.filtro, l = this.todos.filter(function (x) { return !f || Math.round(x.s) === f; });
    var o = this.ordem;
    if (o === 'newest') l.sort(function (a, b) { return b.d - a.d || a._o - b._o; });
    else if (o === 'highest_ratings') l.sort(function (a, b) { return b.s - a.s || a._o - b._o; });
    else if (o === 'lowest_ratings') l.sort(function (a, b) { return a.s - b.s || a._o - b._o; });
    return l;
  };

  /* ---- cartões ---- */
  Avaliacoes.prototype.cartao = function (x) {
    var self = this;
    var item = el('div', 'sftr-av__item');
    item.setAttribute('data-id', x.i);
    var c = el('div', 'sftr-av__cartao');
    c.setAttribute('role', 'button');
    c.setAttribute('tabindex', '0');
    c.setAttribute('aria-label', 'Open review by ' + x.n);
    if (x.f) {
      var foto = el('div', 'sftr-av__foto');
      var prop = el('span', 'sftr-av__foto-proporcao');
      prop.style.paddingBottom = ((x.r || 1.33) * 100) + '%';
      var img = el('img');
      img.src = tamanho(x.f, 600);
      img.alt = 'Customer ' + (x.m === 'video' ? 'video' : 'photo') + ' review of ' + this.titulo;
      img.loading = 'lazy';
      img.decoding = 'async';
      foto.appendChild(prop);
      foto.appendChild(img);
      if (x.m === 'video') foto.insertAdjacentHTML('beforeend', PLAY);
      c.appendChild(foto);
    }
    var corpo = el('div', 'sftr-av__corpo');
    var nome = el('div', 'sftr-av__nome');
    nome.appendChild(document.createTextNode(x.n));
    if (x.v) nome.appendChild(el('span', 'sftr-av__verificada', VERIFICADA + '<span>Verified</span>'));
    corpo.appendChild(nome);
    var d = el('div', 'sftr-av__data'); d.textContent = data(x.d); corpo.appendChild(d);
    var nota = el('div', 'sftr-av__nota');
    var est = el('span', 'sftr-av__estrelas sftr-av__estrelas--cartao', estrelas(x.s));
    est.setAttribute('role', 'img');
    est.setAttribute('aria-label', Math.round(x.s) + ' / 5 star review');
    nota.appendChild(est);
    corpo.appendChild(nota);
    var t = el('div', 'sftr-av__texto'); pintarTexto(t, x.t, x.k); corpo.appendChild(t);
    if (x.p) {
      var meta = el('div', 'sftr-av__meta');
      meta.appendChild(el('div', 'sftr-av__meta-rotulo', 'Item type:'));
      var v = el('div', 'sftr-av__meta-valor'); v.textContent = x.p; meta.appendChild(v);
      corpo.appendChild(meta);
    }
    c.appendChild(corpo);
    item.appendChild(c);
    function abrir() { self.abrir(x); }
    c.addEventListener('click', abrir);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(); } });
    return item;
  };

  Avaliacoes.prototype.montar = function (acrescentar) {
    if (!this.grade) return;
    var l = this.lista(), vis = l.slice(0, this.mostrando);
    var ja = acrescentar ? this.grade.children.length : 0;
    if (!acrescentar) this.grade.innerHTML = '';
    for (var i = ja; i < vis.length; i++) this.grade.appendChild(this.cartao(vis[i]));
    if (this.maisCaixa) this.maisCaixa.hidden = vis.length >= l.length;
    this.arrumar();
  };

  Avaliacoes.prototype.colunas = function (w) {
    if (w >= 920) return 4;
    if (w >= 480) return 3;
    if (w >= 320) return 2;
    return 1;
  };

  /* cada cartão entra na coluna mais curta (empate: a da esquerda) */
  Avaliacoes.prototype.arrumar = function () {
    if (!this.grade) return;
    var w = this.grade.clientWidth;
    if (!w) return;
    var n = this.colunas(w), largura = w / n, alturas = [];
    for (var k = 0; k < n; k++) alturas.push(0);
    var itens = this.grade.children;
    for (var i = 0; i < itens.length; i++) itens[i].style.width = largura + 'px';
    for (var j = 0; j < itens.length; j++) {
      var it = itens[j], col = 0;
      for (var c = 1; c < n; c++) if (alturas[c] < alturas[col] - 0.5) col = c;
      it.style.transform = 'translate(' + (col * largura) + 'px,' + alturas[col] + 'px)';
      alturas[col] += it.getBoundingClientRect().height;
    }
    this.grade.style.height = (Math.max.apply(null, alturas) + 20) + 'px';
    this.grade.classList.add('is-montada');
  };

  /* ---- janela com a avaliação inteira ---- */
  Avaliacoes.prototype.janela = function () {
    var self = this, j = this.raiz.querySelector('[data-janela]');
    if (!j) return;
    document.body.appendChild(j);
    j.style.setProperty('--sftr-av-cor', this.cor);
    this.j = j;
    j.querySelectorAll('[data-fechar]').forEach(function (b) { b.addEventListener('click', function () { self.fechar(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !j.hidden) self.fechar(); });
  };

  Avaliacoes.prototype.abrir = function (x) {
    var j = this.j;
    if (!j) return;
    var midia = j.querySelector('[data-janela-midia]');
    midia.innerHTML = '';
    midia.classList.remove('is-deitada');
    j.classList.toggle('is-sem-midia', !x.f);
    if (x.vd) {
      var v = el('video');
      v.src = x.vd;
      v.poster = tamanho(x.f, 900);
      v.muted = true; v.autoplay = true; v.loop = true; v.controls = true;
      v.setAttribute('playsinline', '');
      midia.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else if (x.f) {
      var img = el('img');
      img.src = tamanho(x.f, 1200);
      img.alt = 'Customer photo review of ' + this.titulo;
      if ((x.r || 1.33) < 1) { img.classList.add('is-deitada'); midia.classList.add('is-deitada'); }
      midia.appendChild(img);
    }
    j.querySelector('[data-janela-nome]').textContent = x.n;
    j.querySelector('[data-janela-verificada]').hidden = !x.v;
    j.querySelector('[data-janela-estrelas]').innerHTML = estrelas(x.s);
    j.querySelector('[data-janela-data]').textContent = data(x.d);
    pintarTexto(j.querySelector('[data-janela-texto]'), x.c || x.t, x.k);
    j.querySelector('[data-janela-meta]').hidden = !x.p;
    j.querySelector('[data-janela-variante]').textContent = x.p || '';
    j.hidden = false;
    document.body.classList.add('sftr-av-travado');
    this.volta = document.activeElement;
    var fechar = j.querySelector('.sftr-av-janela__fechar');
    if (fechar) fechar.focus({ preventScroll: true });
  };

  Avaliacoes.prototype.fechar = function () {
    if (!this.j) return;
    var v = this.j.querySelector('video');
    if (v) v.pause();
    this.j.hidden = true;
    this.j.querySelector('[data-janela-midia]').innerHTML = '';
    document.body.classList.remove('sftr-av-travado');
    if (this.volta && this.volta.focus) this.volta.focus({ preventScroll: true });
  };

  /* ---- formulário "Write a review" ---- */
  Avaliacoes.prototype.formulario = function () {
    var self = this, f = this.raiz.querySelector('[data-form-janela]'), botoes = this.raiz.querySelectorAll('[data-escrever]');
    if (!f) return;
    document.body.appendChild(f);
    f.style.setProperty('--sftr-av-cor', this.cor);
    this.pintarEstrelas(f);
    function fechar() { f.hidden = true; document.body.classList.remove('sftr-av-travado'); }
    function abrir() {
      f.hidden = false;
      document.body.classList.add('sftr-av-travado');
      var primeiro = f.querySelector('input[type=radio]:checked, textarea');
      if (primeiro) primeiro.focus({ preventScroll: true });
    }
    botoes.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); abrir(); }); });
    f.querySelectorAll('[data-fechar]').forEach(function (b) { b.addEventListener('click', fechar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !f.hidden) fechar(); });
    // volta do envio: mostra o agradecimento (ou o erro) já aberto
    if (f.querySelector('[data-form-ok], [data-form-erro]')) {
      abrir();
      self.raiz.scrollIntoView({ block: 'start' });
    }
  };

  function iniciar() {
    document.querySelectorAll('[data-sftr-av]').forEach(function (r) {
      if (r._sftrAv) return;
      try { r._sftrAv = new Avaliacoes(r); } catch (e) { if (window.console) console.warn('sftr-avaliacoes', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
